import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from '../../services/tenant/tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor(private tenantService: TenantService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isSuperAdminRequest(request.url)) {
      return next.handle(request);
    }

    const slug = this.tenantService.getSlug();
    if (!slug) {
      return next.handle(request);
    }

    const cloned = request.clone({
      headers: request.headers.set('X-Tenant-Slug', slug)
    });
    return next.handle(cloned);
  }

  private isSuperAdminRequest(url: string): boolean {
    return url.includes('/api/v1/super-admin/');
  }
}
